import { inject, Injectable } from '@angular/core';

import { deepEqual } from '@core/utils-legacy';
import {
  AutomationConditionDataValue,
  AutomationConditionType,
  AutomationDescriptionCondition,
} from '@core/workflow-automations-types';
import { AutomationOptionsService } from '@recruitee/workflow-automations-logic';

@Injectable()
export class AutomationConditionHelper {
  private readonly automationOptionsService = inject(AutomationOptionsService);

  private currentConditionsOptions = this.automationOptionsService.currentConditionsOptions;

  public mapFormConditionToDescriptionCondition(
    conditions: Array<{
      type: AutomationConditionType | null;
      data: Record<string, AutomationConditionDataValue>;
    }>,
  ): AutomationDescriptionCondition[] {
    return conditions.map(condition => {
      if (condition.type === null) {
        return {
          type: null,
          data: [],
        };
      }

      const conditionOption = this.currentConditionsOptions().find(
        option => option.type === condition.type,
      );
      if (!conditionOption) {
        return {
          type: condition.type,
          data: [],
        };
      }

      return {
        type: condition.type,
        data: Object.entries(condition.data).map(([key, value]) => {
          const conditionProperty = conditionOption.options.find(opt => opt.name === key);
          if (!conditionProperty) {
            return {
              name: key,
              selectedOptions: [],
            };
          }
          const isMultiSelect = Array.isArray(value);
          const options = (conditionProperty.options || []).filter(conditionPropertyOption => {
            if (value === undefined) {
              return false;
            }

            if (Array.isArray(value)) {
              return value.some(v => deepEqual(v, conditionPropertyOption.value));
            }

            return conditionPropertyOption.value === value;
          });

          return {
            name: key,
            ...(isMultiSelect ? { selectedOptions: options } : { selectedOption: options[0] }),
          };
        }),
      };
    });
  }
}
